import SearchIcon from "@assets/search.svg";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, InputBase, useTheme } from "@mui/material";
import { useRef } from "react";

interface AnnotationSearchProps {
  queryValue: string;
  setQueryValue: (value: string) => void;
}

export const AnnotationSearch = ({
  queryValue,
  setQueryValue,
}: AnnotationSearchProps) => {
  const theme = useTheme();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClear = () => {
    setQueryValue("");
    inputRef.current?.focus();
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: `1px solid ${theme.colours.uIGrey.light._40}`,
        borderRadius: "4px",
        backgroundColor: theme.colours.uIGrey.light._10,
        paddingX: 1,
        paddingY: 1,
        marginLeft: 2,
        marginRight: 1,
        width: "100%",
        maxWidth: 350,
        maxHeight: 40,
        ":hover": {
          borderColor: theme.colours.uIGrey.light._60,
        },
        ":focus-within": {
          border: `2px solid ${theme.colours.primary.mid.dark20}`,
        },
      }}
    >
      <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
        <img
          src={SearchIcon}
          alt="Search"
          width={20}
          height={20}
          style={{
            marginRight: theme.spacing(1),
          }}
        />
        <InputBase
          id="annotation-search"
          inputRef={inputRef}
          placeholder="Search annotations..."
          value={queryValue}
          onChange={(e) => setQueryValue(e.target.value)}
          sx={{
            ...theme.customTypography.label._3,
            flex: 1,
          }}
          inputProps={{ autoComplete: "off" }}
        />
      </Box>
      {queryValue && (
        <IconButton
          size="small"
          onClick={handleClear}
          sx={{ padding: 0.5, marginLeft: theme.spacing(1) }}
          aria-label="Clear search"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};
